import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'

// Get browser language or default to German
const getBrowserLocale = () => {
  const browserLang = navigator.language.split('-')[0]
  return ['de', 'en'].includes(browserLang) ? browserLang : 'de'
}

// Get saved language from localStorage or use browser language
const getSavedLocale = () => {
  const saved = localStorage.getItem('locale')
  return saved || getBrowserLocale()
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getSavedLocale(),
  fallbackLocale: 'de',
  messages: {
    de,
    en
  }
})

// Set HTML lang attribute on initialization
document.documentElement.setAttribute('lang', i18n.global.locale.value)

export default i18n
